// extracted by mini-css-extract-plugin
module.exports = {"contact":"a10a3f92e9--contact--jVzBa","content":"a10a3f92e9--content--o6ofY"};